export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/joshua-stannard-8a26aabcc3fe4dd8289d9f379c9f48c6.jpg";